module.exports = "/_next/static/images/f7d16b2f5785802916794f2b4b69cbb4-fees-right-lg.jpg.webp";